import * as graphql from 'generated/graphql';
import QuillText from 'packages/kakapo-ui-kit/components/editors/QuillText';

export default function OpenQuestionDisplay(props: { item: graphql.EvaluationSubmissionItem }) {
	return <QuillText quill={props.item.openQuestion ?? { ops: [] }} />;
}
